export const BASE_URL = "https://erp-go-558879015455.asia-south1.run.app/";
export const LOGIN = "api/v1/organisation/login";
export const LOGOUT = "api/v1/organisation/logout";
export const TASKS = "api/v1/organisation/tasks";
export const CIRCULARS = "api/v1/organisation/circulars";
export const NOTIFICATIONS = "api/v1/organisation/notifications";
export const CALENDAR = "api/v1/organisation/calendar";
export const TODOS = "api/v1/organisation/todos";
export const ROLES = "api/v1/organisation/roles";
export const DEPARTMENTS = "api/v1/organisation/departments";
export const EMPLOYEES = "api/v1/organisation/employees";
export const USERS = "api/v1/organisation/users";
export const FORGOT_PASSWORD = "api/v1/organisation/forgot_password";
export const CHANGE_PASSWORD = "api/v1/organisation/change_password";
export const PROFILE = "api/v1/organisation";
export const UPDATE_PROFILE = "api/v1/organisation/update";
export const FETCH_TRANSACTION = "api/v1/organisation/transaction/";
export const INSERT_TRANSACTION = "api/v1/organisation/transaction/insert/";
export const INSERT_MASTER_TRANSACTION =
  "api/v1/organisation/transaction/master/insert";
export const INSERT_VM_MASTER_TRANSACTION =
  "api/v1/organisation/transaction/master/insert/VM";
export const INSERT_JOBCARD = "api/v1/organisation/transaction/job_card/insert";
export const JOBCARD = "api/v1/organisation/transaction/job_card/";
export const SELECT_TRANSACTION = "/api/v1/organisation/select_transaction/";
export const FIELD_MASTER = "api/v1/organisation/field_master/";
export const REPORTS = "api/v1/organisation/reports/";
export const GRAPHICAL_REPORTS = "api/v1/organisation/graphical_reports/";
export const TRANSACTION_DETAILS = "api/v1/organisation/transaction/details";
export const CUSTOMER_VENDOR = "api/v1/organisation/company_master/";
export const VENDOR = "api/v1/organisation/vendors";
export const EDIT_TRANSACTION = "api/v1/organisation/transaction/edit/";
export const DELETE_TRANSACTION = "api/v1/organisation/transaction/delete/";
export const APPROVE_TRANSACTION =
  "api/v1/organisation/transaction/approve/details/";
export const FILE_UPLOAD = "api/v1/organisation/file_upload";
export const UPDATE_MENU = "api/v1/organisation/menu/update";
export const EDIT_MASTER_TRANSACTION =
  "api/v1/organisation/transaction/master/edit/";
export const ANALYSIS_REPORT = "api/v1/organisation/analysis_report/";
export const HOME_SUMMARY = "api/v1/organisation/home_summary";
export const POPUP_QUERY = "api/v1/organisation/pop_query";
export const INSERT_PRODUCTMASTER =
  "api/v1/organisation/transaction/product_master/insert";
export const FINALISE_PRODUCTMASTER =
  "api/v1/organisation/transaction/product_master/finalise";
export const EDIT_PRODUCTMASTER =
  "api/v1/organisation/transaction/product_master/edit";
export const TRANSACTION_NUMBER =
  "api/v1/organisation/transaction/get_tran_no/";
export const CREATE_MATERIAL_REQUEST =
  "api/v1/organisation/transaction/create_auto_mr";
export const PRODUCTS = "api/v1/organisation/product_categories";
export const VENDOR_CATEGORIES = "api/v1/organisation/vendor_categories";
export const PACKING_LIST =
  "api/v1/organisation/product_master_transaction/details";
export const INSPECTION_ITEM = "api/v1/organisation/inspection_report";
export const SETTING = "api/v1/organisation/";
export const PROCESS_CARD_FETCH = "api/v1/organisation/process_card/";
export const ROUTECARD_FETCH = "api/v1/organisation/route_card/";
export const ROUTECARD_CARD_UPDATE = "api/v1/organisation/route_card/update/";
export const ROUTECARD_CARD_CREATE = "api/v1/organisation/route_card/create";
export const PROCESS_CARD_CREATE = "api/v1/organisation/process_card/create";
export const PROCESS_CARD_UPDATE = "api/v1/organisation/process_card/update/";
export const CREATE_JOBCARD = "api/v1/organisation/transaction/create_jobcard";
export const FETCH_TRANSACTION_SETTINGS_CODE =
  "api/v1/organisation/transaction_settings/";
export const UPDATE_TRANSACTION_SETTINGS =
  "api/v1/organisation/transaction_settings/update";
export const ROUTECARD_START_FINISH =
  "api/v1/organisation/route_card/start_finish/";
export const ROUTECARD_PROCESS_START =
  "api/v1/organisation/transaction/route_card/process/start";
export const ROUTECARD_PROCESS_FINISH =
  "api/v1/organisation/transaction/route_card/process/finish";
export const FETCH_SUBCATEGORY = "api/v1/organisation/subcategory";
export const VENDOR_CATEGORY_LIST = "api/v1/organisation/category";
export const VENDOR_SUBCATEGORY_LIST = "api/v1/organisation/subcategory/list";
export const CREATE_SUBCATEGORY = "api/v1/organisation/subcategory/create";
export const UPDATE_SUBCATEGORY = "api/v1/organisation/subcategory/update/";
export const DELETE_SUBCATEGORY = "api/v1/organisation/subcategory/delete/";
export const INSERT_WBOM = "api/v1/organisation/transaction/wbom/insert";
export const BOM_BY_PRODUCT = "api/v1/organisation/transaction/bom/by_product/";
export const QUOTATION_REVISE =
  "api/v1/organisation/transaction/quotation/revise/";
export const QUOTATION_VERSIONS =
  "api/v1/organisation/transaction/quotation/versions/";
export const LAST_HEAD_DATA = "api/v1/organisation/transaction/last_head_data/";
export const INVENTORY_DASHBOARD = "api/v1/organisation/inventory/dashboard";
export const INVENTORY_BALANCE = "api/v1/organisation/inventory/balance";
export const INVENTORY_LEDGER = "api/v1/organisation/inventory/ledger";
export const INVENTORY_AVAILABILITY =
  "api/v1/organisation/inventory/availability";
  
